import './Accordion.css';
import  {useEffect } from 'react';

const AccordionItemRich =(props) =>{

    
  useEffect(()=>{
    addEventListener("keydown",props.handleUserKeypress);
    return()=>{
        removeEventListener("keydown",props.handleUserKeypress);
    }
  },[]);

    let text1 = props.data.FaqRichText1 ? <div className="text1" dangerouslySetInnerHTML={{__html: props.data.FaqRichText1 }}/> : null;
    let text2 = props.data.FaqRichText2 ? <div className="text2" dangerouslySetInnerHTML={{__html: props.data.FaqRichText2 }}/> : null;
    let link1 = props.data.FaqLink1 ? <div className="link1 linkFormDiv"><a href={props.data.FaqLink1.NavigateUrl} className="linkForm">{props.data.FaqLink1_Value || props.data.FaqLink1.Text}</a></div> : null;
    let link2 = props.data.FaqLink2 ? <div className="link2 readMoreDiv"><a href={props.data.FaqLink2.NavigateUrl} className="readMoreLink">{props.data.FaqLink2_Value || props.data.FaqLink2.Text}<i className="fa fa-arrow-left"></i></a></div> : null;
    let form1 = props.data.FaqForm1 ? <div className="form1 formDiv"><a href={props.data.FaqForm1.NavigateUrl}>{props.data.FaqForm1_Value || props.data.FaqForm1.Text}</a></div> : null;
    let form2 = props.data.FaqForm2 ? <div className="form2 formDiv"><a href={props.data.FaqForm2.NavigateUrl}>{props.data.FaqForm2_Value || props.data.FaqForm2.Text}</a></div> : null;
    let form3 = props.data.FaqForm3 ? <div className="form3 formDiv"><a href={props.data.FaqForm3.NavigateUrl}>{props.data.FaqForm3_Value || props.data.FaqForm3.Text}</a></div> : null;
    let form4 = props.data.FaqForm4 ? <div className="form4 formDiv"><a href={props.data.FaqForm4.NavigateUrl}>{props.data.FaqForm4_Value || props.data.FaqForm4.Text}</a></div> : null;
    let form5 = props.data.FaqForm5 ? <div className="form5 formDiv"><a href={props.data.FaqForm5.NavigateUrl}>{props.data.FaqForm5_Value || props.data.FaqForm5.Text}</a></div> : null;
    let newsDate = props.data.MODNewsPublishDate ? <div className="NewsDate">{
      new Intl.DateTimeFormat('en-GB').format(new Date(props.data.MODNewsPublishDate)) }</div> : null;
    let forms = form1 || form2 || form3 ? <div className="formsDiv"><h3>טפסים</h3> {form1}{form2}{form3}</div> : null;
    let itemFooter = text2 || link2 ?  <div className="itemFooter"> {text2}{link2}</div> : null;
  

    return (
      // + (props.isOpen ? 'open' : '')
      <div className={'accordion-item modCard '} key={"AccordionCategory_"+props.index}>
        <div className="title modCard-header" id={"accHead_" + props.WpId +"_"+ props.index} >
          <h3 className="mb-0">
            <a role="button" className={"btn btn-link "+(props.isOpen ? '' : 'collapsed')} data-toggle="collapse" data-target={"#accColapse_" + props.WpId +"_"+ props.index} 
            // onClick={e => props.toggleItem(e)}
                aria-expanded="false" aria-controls={"accColapse_" + props.WpId +"_"+ props.index} >
                  {/*  {(props.isOpen ? '-' : '+')} */}
              <span className="fa openclose"></span>
              <div className="itemTitle">
                {props.data.Title}
                {newsDate} 
              </div>
            </a>
          </h3>
        </div>
        <div id={"accColapse_" + props.WpId +"_"+ props.index} className= {(props.isOpen ? "collapse show" : 'collapse')} aria-labelledby={"accHead" + props.WpId +"_"+ props.index} 
            data-parent={"#modAccordion_" + props.WpId }>
          <div className="modCard-body" > 
            <div className="itemHead">
              {text1}
              {link1}
            </div>
            {forms}
            {itemFooter}
          </div>
        </div>
      </div>
    );
}


export default AccordionItemRich;